import moment from "moment";

export const propsArquivos = [
  "Arquivos",
  "ArquivosNoPrazo",
  "ArquivosForaDoPrazo",
  "ArquivosErro",
  "ArquivosStage",
];

export const propsOcorrencias = [
  "Ocorrencias",
  "OcorrenciasNoPrazo",
  "OcorrenciasForaDoPrazo",
  "OcorrenciasErro",
  "OcorrenciasStage",
];

const getTransportadoras = (
  data: any[],
  tipoDocumento?: string | undefined
) => {
  let transportadoras = [];
  data.forEach((item) => {
    const tipoDocEntrega = "Entrega";
    const tipoDocReversa = "Reversa";
    const tipoDocTotal = "Total";
    const tipoDocTodos = "Todos";
    const tipoDoc3PEnvvias = "CB Entrega";
    switch (tipoDocumento) {
      case tipoDocEntrega:
        if (item.tipoDocumentoDescricao === tipoDocEntrega) {
          transportadoras = transportadoras.concat(item.transportadoras);
        }
        return;
      case tipoDocReversa:
        if (item.tipoDocumentoDescricao === tipoDocReversa) {
          transportadoras = transportadoras.concat(item.transportadoras);
        }
        return;
      case tipoDocTotal || tipoDocTodos:
        if (
          item.tipoDocumentoDescricao === tipoDoc3PEnvvias ||
          item.tipoDocumentoDescricao === tipoDocEntrega ||
          item.tipoDocumentoDescricao === tipoDocReversa
        ) {
          transportadoras = transportadoras.concat(item.transportadoras);
        }
        return;
      case tipoDoc3PEnvvias:
        if (item.tipoDocumentoDescricao === tipoDoc3PEnvvias) {
          transportadoras = transportadoras.concat(item.transportadoras);
        }
        return;
      case "MP":
        if (item.tipoDocumentoDescricao === tipoDoc3PEnvvias) {
          transportadoras = transportadoras.concat(item.transportadoras);
        }
        return;
      default:
        transportadoras = transportadoras.concat(item.transportadoras);
        return;
    }
  });
  return transportadoras;
};

const getData = (transportadoras: any[], prop: string) => {
  let data: any = [];
  if (prop) {
    transportadoras.forEach((item: any) => {
      const filtered = item[prop].filter(
        (x: { horario: string }) => x.horario !== "Total"
      );

      filtered.forEach((_, index) => {
        if (!data[index]) {
          data[index] = {
            quantidade: 0,
            horario: filtered[index].horario,
          };
        }
        data[index].quantidade =
          Number(data[index].quantidade) + Number(filtered[index].quantidade);
      });
    });
  }
  return data;
};

const getTotal = (data: any[]) => {
  let totalValue = 0;
  data.forEach((item: any) => {
    totalValue = totalValue + Number(item.quantidade);
  });
  return { totalValue, dataValue: data };
};

export const qtdTotal = (
  data: any,
  total?: any,
  noPrazo?: any,
  foraDoPrazo?: any,
  erros?: any,
  stage?: any,
  tipoDocumento?: any
) => {
  const totalGeral = getTotal(
    getData(getTransportadoras(data, tipoDocumento), total)
  );
  const totalNoPrazo = getTotal(
    getData(getTransportadoras(data, tipoDocumento), noPrazo)
  );
  const totalForaDoPrazo = getTotal(
    getData(getTransportadoras(data, tipoDocumento), foraDoPrazo)
  );
  const totalDeErros = getTotal(
    getData(getTransportadoras(data, tipoDocumento), erros)
  );
  const totalStage = getTotal(
    getData(getTransportadoras(data, tipoDocumento), stage)
  );

  return {
    totalGeral,
    totalNoPrazo,
    totalForaDoPrazo,
    totalDeErros,
    totalStage,
  };
};

const sortF = (a, b) => {
  return a.qtdErros - b.qtdErros;
};

export const getTransportadorasCErros = (
  data,
  propErrName: string,
  tipoDocumento
) => {
  const transportadoras = getTransportadoras(data, tipoDocumento);
  const totalComErros: any = [];
  transportadoras.forEach((item: any) => {
    const cErros = item[propErrName].filter(
      (x: { quantidade: string }) => x.quantidade !== "" && x.quantidade !== "0"
    );

    if (cErros.length > 0) {
      totalComErros.push({
        qtdErros: item[propErrName][0].quantidade,
        transportadora: item.nomeTransportadora,
      });
    }
  });
  return totalComErros.sort(sortF).reverse();
};

const sortAlpha = (a, b) => {
  if (a.nome < b.nome) {
    return -1;
  }
  if (a.nome > b.nome) {
    return 1;
  }
  return 0;
};

const changePropText = (text): string => {
  switch (text) {
    case "arquivos":
      return "Arquivos";
    case "ocorrencias":
      return "Ocorrencias";
    default:
      return "";
  }
};

export const getDataForList = (data, prop: any, tipoDocumento) => {
  const transportadoras = getTransportadoras(data, tipoDocumento);
  let horarios: any = [],
    transportadorasData: any = [];
  transportadoras.forEach((item: any) => {
    let newPropText = changePropText(prop);
    item[newPropText].forEach((_, index) => {
      if (!horarios[index]) {
        if (item[newPropText][index].horario !== "Total") {
          horarios[index] = {
            horario: item[newPropText][index].horario,
          };
        }
      }
      if (item[newPropText][index].horario !== "Total") {
        horarios[index].horario = item[newPropText][index].horario;
      }
    });

    let x: any = [];
    item.transportadoras.forEach((transportadora) => {
      x.push({
        nome: transportadora.transportadoras,
        dataValue: transportadora[newPropText],
      });
    });

    transportadorasData.push({
      nome: item.nomeTransportadora,
      transportadoras: x,
      dataValue: item[newPropText],
      horarios: horarios.filter((x: undefined) => x !== undefined),
    });
  });

  let transportadorasSort: any;
  transportadorasSort = transportadorasData.sort(sortAlpha);

  return transportadorasSort;
};

export const getPedidos = (data: any[], tipoDocumento?: string | undefined) => {
  let pedidos = [];
  if (data) {
    data.forEach((item) => {
      const tipoDocEntrega = "Entrega";
      const tipoDocReversa = "Reversa";
      const tipoDocTotal = "Total";
      const tipoDocTodos = "Todos";
      const tipoDoc3PEnvvias = "CB Entrega";
      switch (tipoDocumento) {
        case tipoDocEntrega:
          if (item.tipoDocumentoDescricao === tipoDocEntrega) {
            pedidos = pedidos.concat(item.pedidos);
          }
          return;
        case tipoDocReversa:
          if (item.tipoDocumentoDescricao === tipoDocReversa) {
            pedidos = pedidos.concat(item.pedidos);
          }
          return;
        case tipoDocTotal || tipoDocTodos:
          if (
            item.tipoDocumentoDescricao === tipoDoc3PEnvvias ||
            item.tipoDocumentoDescricao === tipoDocEntrega ||
            item.tipoDocumentoDescricao === tipoDocReversa
          ) {
            pedidos = pedidos.concat(item.pedidos);
          }
          return;
        case tipoDoc3PEnvvias:
          if (item.tipoDocumentoDescricao === tipoDoc3PEnvvias) {
            pedidos = pedidos.concat(item.pedidos);
          }
          return;
        default:
          pedidos = pedidos.concat(item.pedidos);
          return;
      }
    });
  }
  return pedidos;
};

export const verifyDateTimeDiffMin = (dateTimeInitial, dateTimeFinal) => {
  if (!dateTimeInitial || !dateTimeFinal) return false;
  if (
    moment(dateTimeInitial).diff(moment(dateTimeFinal), "minutes") > 30 ||
    moment(dateTimeFinal).diff(moment(dateTimeInitial), "minutes") > 30
  ) {
    return false;
  }
  return true;
};

export const verifyDateTimeDiffHours = (dateTimeInitial, dateTimeFinal) => {
  if (moment(dateTimeInitial).diff(moment(dateTimeFinal), "hours") > 1) {
    return false;
  } else if (
    moment(dateTimeInitial).diff(moment(dateTimeFinal), "hours") < -24 ||
    moment(dateTimeFinal).diff(moment(dateTimeInitial), "hours") > 24
  ) {
    return false;
  }
  return true;
};

export const parseQuery = (data: {
  dataHoraInicial: string;
  dataHoraFinal: string;
  tipoDocumento: string;
  idApelido: string;
}) => {
  const { dataHoraInicial, dataHoraFinal, tipoDocumento, idApelido } = data;
  const tipoDoc =
    tipoDocumento === "Comprovantes" || tipoDocumento === "Total"
      ? "Todos"
      : tipoDocumento;
  return {
    dataHoraInicial,
    dataHoraFinal,
    tipoDocumento: tipoDoc,
    apelidoTransportadora: idApelido,
  };
};

export const formatArrTransportadoras = (arr) => {
  let newArr: any[] = [];
  newArr = arr.map((item) => {
    return {
      name: item,
    };
  });
  return newArr;
};

export const changeFilterForSelect = (filter: string) => {
  switch (filter) {
    case "Entrega":
      return "entrega";
    case "Reversa":
      return "reversa";
    case "Total":
      return "total";
    case "Comprovantes":
      return "comprovantes";
    case "CB Entrega":
      return "MP";
  }
};
